import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import Button from '../../../components/global/Button';
import { getAsset } from '../../../util/assets';
import Spinner from '../../../components/global/Spinner';
import { getAccountOrganizationName } from '../../../util/account';
import Badge from '../../../components/global/Badge';

class WebGalleryUpsellModal extends Component {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    onDismiss: PropTypes.func,
    loadingAlbum: PropTypes.bool,
    loadingUserData: PropTypes.bool,
    album: PropTypes.shape({
      id: PropTypes.string,
      root_album_folder: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
      album_type: PropTypes.string,
      album_subtype: PropTypes.string,
    }),
    user: PropTypes.shape({
      id: PropTypes.string,
      email_address: PropTypes.string,
      email_verified: PropTypes.bool,
    }),
    authenticated: PropTypes.bool,
  };

  onDismiss = () => {
    const { onRequestClose, onDismiss } = this.props;

    onRequestClose();

    if (onDismiss) {
      onDismiss();
    }
  };

  getUpsellUrl = () => {
    const { album, user, authenticated } = this.props;
    const rootAlbumFolderId = album?.root_album_folder?.id;

    // If the user is authenticated with a phone number
    // send them to select identities
    if (authenticated && user && user.phone_number) {
      return {
        pathname: `/discover/album-folder/${rootAlbumFolderId}/faces`,
      };
    }

    // Else send the user to phone auth
    // (i.e. either authenticated with email (no phone number) or
    // not authenticated).
    const targetUrl = `/discover/album-folder/${rootAlbumFolderId}`;
    return {
      pathname: '/auth/phone',
      search: `?${qs.stringify({ next: targetUrl })}`,
    };
  };

  render() {
    const { loadingAlbum, loadingUserData, album } = this.props;

    if (loadingAlbum || loadingUserData) {
      return (
        <div className="text-center p-2">
          <Spinner />
        </div>
      );
    }

    return (
      <div className="web-gallery-upsell p-1 p-md-4 text-center">
        <div className="web-gallery-upsell-title">
          <h3 className="mb-1">
            Welcome to <br />
            <span className="text-black">{album.name}</span>
          </h3>
          {album.creator?.username && (
            <p className="text-center text-xs">
              by{' '}
              <a
                href={`/@${album.creator.username}`}
                target="_blank"
                rel="noreferrer"
              >
                {getAccountOrganizationName(
                  album.creator,
                  `@${album.creator.username}`,
                )}
              </a>
            </p>
          )}
        </div>

        <div className="row">
          <div className="col-12">
            <div className="web-gallery-upsell-comparison d-none d-md-flex">
              <img src={getAsset('/waldo-way.png')} alt="Waldo Way" />
              <div className="spacer" />
              <img src={getAsset('/old-way.png')} alt="Old Way (Not Waldo)" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="d-flex flex-column h-100">
              <div className="d-flex align-items-center justify-content-center mb-3 ">
                <p className="text-bold text-dark mb-0 mb-md-2">
                  I want Waldo to find my photos and text them to me.
                </p>
                <img
                  className="d-md-none w-50"
                  src={getAsset('/waldo-way.png')}
                  alt="Waldo Way"
                />
              </div>
              <Button
                btnBlock
                to={this.getUpsellUrl()}
                className="mt-auto pos-rel web-gallery-upsell-button web-gallery-upsell-onboard"
              >
                <Badge
                  badgeStyle="yellow"
                  badgeSize="xs"
                  className="web-gallery-upsell-badge"
                >
                  Popular!
                </Badge>
                Find my photos
              </Button>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="d-flex flex-column h-100">
              <div className="d-flex align-items-center justify-content-center mb-3">
                <p className="text-dark mb-0 mb-md-2">
                  No thanks, I’ll go on a scavenger hunt.
                </p>
                <img
                  className="d-md-none w-50"
                  src={getAsset('/old-way.png')}
                  alt="Old Way (Not Waldo)"
                />
              </div>

              <Button
                className="mt-auto web-gallery-upsell-button"
                onClick={this.onDismiss}
                btnOutline
                btnBlock
              >
                Just Browse
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WebGalleryUpsellModal;
